<template>
  <formula-form v-model="formula" :givenOutput="gotOutput" @update="onUpdate" />
</template>

<script>
import FormulaForm from "./form/FormulaForm.vue";
export default {
  name: "CreateFormula",

  components: {
    FormulaForm,
  },

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },

  model: {
    prop: "value",
  },

  data() {
    return {
      formula: {
        outputDeveui: "",
        outputKey: "",
      },
      componentKey: 0,
    };
  },

  computed: {
    gotOutput() {
      return this.formula.outputDeveui !== "";
    },
  },

  methods: {
    onUpdate() {
      this.gotOutput ? this.$emit("update") : this.$router.push("/formula");
    },
  },

  async created() {
    if (this.value.deveui) {
      this.formula.outputDeveui = this.value.deveui;
      this.formula.outputKey = this.value.key ?? "";
    }
  },
};
</script>
